import mixpanel from 'mixpanel-browser';

mixpanel.init("b4f4be96ff62ab75a435c00930abf301");

let env_check = process.env.NODE_ENV === 'production';

let Analytics = {
  identify: (id) => {
    if (env_check) mixpanel.identify(id);
  },
  alias: (id) => {
    if (env_check) mixpanel.alias(id);
  },
  landingPageOpen: () => {
    if (env_check) mixpanel.track('Landing Page Open');
  },
  playVideo: () => {
    if (env_check) mixpanel.track('Play Video');
  },
  track: (name, props) => {
    if (env_check) mixpanel.track(name, props);
  },
  people: {
    set: (props) => {
      if (env_check) mixpanel.people.set(props);
    },
  },
};

export default Analytics;